import React from 'react'
import { connect } from 'react-redux'
import FloorPlan from 'components/FloorPlan'
import { floorPlanLoadedAction } from 'actions/exportActions'

const mapStateToProps = ({ map: { floorPlans }, createdAt }) => ({ floorPlans, createdAt })

function googlifyLocaiton(location) {
  const nw = new google.maps.LatLng(location.nw.lat, location.nw.lng)
  const se = new google.maps.LatLng(location.se.lat, location.se.lng)
  return { nw, se }
}

class FloorPlansContainer extends React.Component {
  render() {
    const { props: { mapContextMenuEventHandler, contextMenuOptions, floorPlans,
      floorPlanLoadedAction, map, createdAt } } = this
    return (
      <div>
        { map &&
          floorPlans.map(f =>
            <FloorPlan
              {...f}
              key={createdAt + f.id}
              location={googlifyLocaiton(f.location)}
              mapContextMenuOptions={contextMenuOptions}
              {...{ map, floorPlanLoadedAction, mapContextMenuEventHandler }}
            />
          )
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, { floorPlanLoadedAction })(FloorPlansContainer)



// WEBPACK FOOTER //
// ./src/components/FloorPlansContainer/index.js